module.exports = __webpack_public_path__ + "img/logo.eb2a4349.png";